import React from 'react';
import { Row, Col } from 'react-flexbox-grid';
import ReactSVG from 'react-svg';
import styled from 'styled-components';

import { PageGrid } from '../shared/CommonStyledComponents';
import NextPageLink from '../shared/NextPageLink';

import workWithUsTeam from '../assets/images/work_with_us_team.svg';
import blogSideLink from '../assets/images/sideLinks/blog_side_link.svg';


const WorkWithUsRow = styled(Row)`
  width: 85%;

  @media (max-width: 64em) {
    width: auto;
  }
`;

const WorkWithUsContentColumn = styled(Col)`
  display: flex;
  align-items: center;
`;

const WorkWithUsContent = styled.p`
  font-size: 1vw;
  line-height: 1.4vw;

  @media (max-width: 64em) {
    font-size: 3vw;
    line-height: 4.2vw;
  }
`;

const JoinUsLink = styled.a`
  margin-top: 1vw;
  background-color: #FF9D00;
  padding: 0.7vw 2vw;
  display: inline-block;
  text-align: center;
  font-size: 1.3vw;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  position: relative;
  overflow: hidden;
  -webkit-transition: color 0.4s;
  transition: color 0.4s;
  color: #262636;
  text-decoration: none;
  outline: none;

  &:after{
    background-color: #2e9aff;
    content: '.';
    transform: skewX(15deg);
    position: absolute;
    top: 0;
    left: -10%;
    height: 100%;
    width: 0%;
    color: #2e9aff;
    z-index: 1;
    -webkit-transition: width 0.4s;
    transition: width 0.4s;
  }

  .link-text{
    z-index: 4;
    position: relative;
  }

  &:hover{
    color: #fff;

    &:after{
      width: 120%;
    }
  }

  @media (max-width: 64em) {
    padding: 1.7vw 6vw;
    font-size: 4.3vw;
    margin-top: 5vw;
    margin-bottom: 12vw;
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 29vw;
  }
`;

const WorkWithUs = () => (
  <PageGrid id="workwithus">
    <WorkWithUsRow>
      <WorkWithUsContentColumn xs={12} md={5}>
        <div>
          <WorkWithUsContent>
            We are looking for interesting young people to join our unique family.
            Yes, we are a unique team. We enjoy our work. We always try to do something different.
            You can say we are a team of mad scientists. But we know what we are doing. And oh we
            also do podcasts!
          </WorkWithUsContent>

          <WorkWithUsContent>
            We work in many different areas. Web sites, Web applications, Desktop applications,
            Mobile applications, and many other kinds of software. Our main language is JavaScript.
            We worship it every day. Note that it&apos;s not the old scripting language anymore.
            It&apos;s a very powerful programming language which can be used to build many different
            software applications.
          </WorkWithUsContent>

          <WorkWithUsContent>
            We always value quality work. If you can&apos;t do it in the most efficient,
            secure and clean way, you should re-adjust your course. If you join our team,
            we will train you to be a great developer who codes better and even have better
            qualities as a human being. So, do you think you can handle all of it? If you do,
            come...
          </WorkWithUsContent>

          <JoinUsLink
            href="https://forms.gle/fYaPxvvcpTRLVYEy9"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="link-text">join us...</span>
          </JoinUsLink>
        </div>
      </WorkWithUsContentColumn>
      <Col xs={12} md={7}>
        <ReactSVG
          path={workWithUsTeam}
        />
      </Col>
    </WorkWithUsRow>
    <NextPageLink
      color="2E9AFF"
      image={blogSideLink}
      text="OUR BLOG"
      blog
    />
  </PageGrid>
);

export default WorkWithUs;



// WEBPACK FOOTER //
// ./src/components/WorkWithUs.js